import { render } from "./NotificationButton.molecule.vue?vue&type=template&id=19cd57c8&bindings={\"iconName\":\"props\",\"isAnimated\":\"props\",\"hasNotification\":\"props\"}"
import script from "./NotificationButton.molecule.vue?vue&type=script&lang=ts"
export * from "./NotificationButton.molecule.vue?vue&type=script&lang=ts"
script.render = render

export default script